import { makeStyles, Button as MuiButton } from "@material-ui/core";
import { darken, fade } from "@material-ui/core/styles";
import clsx from "clsx";
import React from "react";
import CircularProgresss from "../CircularProgress";
const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: "auto",
      minWidth: "100px",
      "& .MuiSvgIcon-root": {
        color: ({ variant, color }) =>
          variant === "contained" &&
          color !== "error" &&
          theme.palette.common.white,
      },
    },
    // MUI v4's Button only generates primary/secondary variant styles, so
    // color="error" (destructive actions — Delete, Reject, ...) needs its
    // own classes here rather than being passed straight through to MUI.
    // This is the project-wide standard for a red delete/destructive button.
    errorContained: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.common.white,
      "&:hover": { backgroundColor: darken(theme.palette.error.main, 0.15) },
      "&.Mui-disabled": {
        backgroundColor: theme.palette.action.disabledBackground,
      },
    },
    errorOutlined: {
      color: theme.palette.error.main,
      borderColor: theme.palette.error.main,
      "&:hover": {
        backgroundColor: fade(theme.palette.error.main, 0.08),
        borderColor: theme.palette.error.main,
      },
    },
    errorText: {
      color: theme.palette.error.main,
      "&:hover": { backgroundColor: fade(theme.palette.error.main, 0.08) },
    },
  }),
  { name: "CommonButton" }
);
export const Button = React.memo(
  ({
    startIcon,
    variant,
    color,
    size,
    className,
    disabled,
    text,
    onClick,
    children,
    loading = false,
    ...rest
  }) => {
    const classes = useStyles({ variant, color });
    const isError = color === "error";
    const errorClass = isError
      ? {
          contained: classes.errorContained,
          outlined: classes.errorOutlined,
        }[variant] || classes.errorText
      : undefined;
    return (
      <MuiButton
        onClick={onClick}
        variant={variant}
        color={isError ? undefined : color}
        size={size}
        disabled={loading || disabled}
        className={clsx(classes.root, errorClass, className)}
        startIcon={loading ? <CircularProgresss /> : startIcon}
        {...rest}
      >
        {text ?? children}
      </MuiButton>
    );
  }
);
